module.exports = __webpack_public_path__ + "img/charity_thumbnail.9133b837.jpg";